import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PasswordCreator from '../Auth/PasswordCreator';
import Loader from '../Common/Loader';
import { withRouter } from 'react-router-dom';
import { withStyles, createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { grey } from '@material-ui/core/colors';
import Icon from '@projeccions-pdc/react-icon';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import DialogActions from '@material-ui/core/DialogActions';
import LocalizedStrings from '../Localization/localization';
import AppContext from '../../AppContext';
import AuthController from '../Auth/AuthController';
import languages from '../../language-codes.json';
import SimpleField from '../Auth/SimpleField';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import { makeStyles } from '@material-ui/core/styles';
import { isSmartphone } from '../../helpers';
import Tools from './Tools';
import { version } from '../../../package.json';
import IdentityService from '../../apiclients/IdentityService';
import Countries from '../Common/Countries';
import * as _ from 'lodash';

const styles = (theme) => ({
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        marginBottom: '10px',
    },
    platformButtonContainer: {
        display: 'inline-block',
        textAlign: 'center',
        margin: '10px',
        fontSize: '12px',
    },
    tableColumn: {
        display: 'inline-block',
        paddingRight: '50px',
        width: 'calc(50% - 10px)',
        verticalAlign: 'top',
        // borderRight: '1px solid #000',
    },
    tableColumnTwo: {
        display: 'inline-block',
        // paddingRight: '10px',
        width: 'calc(50% - 40px)',
        verticalAlign: 'top',
    },
    tableColumnSmartphone: {
        verticalAlign: 'top',
    },
    userProfile: {
        display: 'block',
    },
});

class UserSettingsModal extends Component {
    constructor(props) {
        super(props);
        let appContext = new AppContext();
        this.state = {
            fields: {
                password1: '',
                password2: '',
                smartphoneView: undefined,
            },
            oldPassword: '',
            passwordError: false,
            isUserSettingsOpen: false,
            name: appContext.getMyInfo().name,
            userProfileData: appContext.getUserProfileData(),
        };
    }

    componentDidMount() {
        isSmartphone((match) => this.handleSizeChange(match));
    }

    handleSizeChange = (match) => {
        this.setState({ smartphoneView: match });
    };

    handleIconEdit = () => {
        console.log('handleIconEdit', 'Do something');
    };

    handleOldPasswordChange = (evt) => {
        let oldPassword = evt.value;
        let oldPasswordError = oldPassword === '' || !oldPassword ? true : false;
        this.setState({ oldPassword, oldPasswordError });
    };

    onPasswordInputChange = (name, value, error) => {
        const fields = this.state.fields;
        const fieldErrors = this.state.fieldErrors;
        fields[name] = value;
        this.setState({ fieldErrors, fields, passwordError: error });
    };

    changePassword = async () => {
        if (!this.state.oldPassword || this.state.oldPassword === '') {
            let message = LocalizedStrings.oldPasswordEmptyError;
            if (this.props.notify) {
                this.props.notify('error', message);
            } else {
                console.log(message);
            }
            return;
        }

        if (this.state.passwordError === true || this.state.fields.password1 === '') {
            let message = LocalizedStrings.errorPasswordFormat;
            if (this.props.notify) {
                this.props.notify('error', message);
            } else {
                console.log(message);
            }
            return;
        }

        AuthController.changePassword(this.state.oldPassword, this.state.fields.password1, this.props.notify).then((response) => {
            this.setState({
                fields: {
                    password1: '',
                    password2: '',
                },
                oldPassword: '',
                passwordError: false,
            });
        });
    };

    handleLogout = async () => {
        this.setState({ logoutLoading: true });
        await AuthController.signOut(this.props.history);
        this.setState({ logoutLoading: false });
    };

    // onPlatformIdChanged = () => {
    //     this.closeModal();
    // }

    handleModalToggle = () => {
        this.setState({ isUserSettingsOpen: !this.state.isUserSettingsOpen });
        if (this.props.toggleUserSettings) {
            this.props.toggleUserSettings();
        }
    };

    closeModal = () => {
        if (this.props.toggleUserSettings) {
            this.props.toggleUserSettings(false);
        }
        this.setState({ isUserSettingsOpen: false });
    };

    handleLanguageChange = (evt) => {
        let lang = evt.target.value;
        let appContext = new AppContext();
        appContext.setLanguage(lang);
        this.forceUpdate();
    };

    handleProfileValueChanged = (evt) => {
        if (evt.name !== 'name') {
            if (evt.target !== undefined) {
                evt = evt.target;
            }
            let userProfileData = _.cloneDeep(this.state.userProfileData);
            userProfileData[evt.name] = evt.value;
            this.setState({ userProfileData });
        } else {
            // Name
            this.setState({ name: evt.value });
        }
    };

    handleSubmitUserPorfileValues = async () => {
        const name = this.state.name;
        let userProfileData = _.cloneDeep(this.state.userProfileData);

        try {
            if (name === undefined || name.trim() === '') {
                throw new Error('Name is empty');
            }
            await IdentityService.setUserProfileData(name, userProfileData);
            let appContext = new AppContext();
            appContext.setUserProfileData(userProfileData);
            if (this.props.notify) {
                this.props.notify('info', LocalizedStrings.updateUserProfileDataOK);
            } else {
                console.log(LocalizedStrings.updateUserProfileDataOK);
            }
        } catch (err) {
            console.log(err);
            if (this.props.notify) {
                this.props.notify('error', LocalizedStrings.updateUserProfileDataError);
            } else {
                console.log(err);
            }
        }
    };

    validateField = (val) => {
        return val === undefined || val === '';
    };

    renderContent = () => {
        const { classes } = this.props;

        let columnStyle = classes.tableColumn;
        let columnStyleTwo = classes.tableColumnTwo;
        if (this.state.smartphoneView === true) {
            columnStyle = classes.tableColumnSmartphone;
            columnStyleTwo = classes.tableColumnSmartphone;
        }
        let appContext = new AppContext();
        let language = appContext.getLanguage();
        let myInfo = appContext.getMyInfo();

        return (
            <div style={{ position: 'relative' }}>
                <div className={columnStyle}>
                    <h3>{LocalizedStrings.userSettings}</h3>
                    <SimpleSelect placeholder={LocalizedStrings.language} value={language} onChange={this.handleLanguageChange}>
                        {languages.map((lang) => {
                            return (
                                <MenuItem key={lang['alpha2']} value={lang['alpha2']}>
                                    {lang.name}
                                </MenuItem>
                            );
                        })}
                    </SimpleSelect>
                    <br />
                    <br />

                    <Accordion>
                        <AccordionSummary expandIcon={<Icon name="md-expand-more" />}>{LocalizedStrings.profileDetails}</AccordionSummary>
                        <AccordionDetails className={classes.userProfile}>
                            <SimpleField
                                placeholder={LocalizedStrings.email}
                                name="email"
                                inputType="text"
                                value={myInfo.email}
                                onChange={() => {}}
                                validate={this.validateField}
                                disabled={true}
                            />
                            <SimpleField
                                placeholder={LocalizedStrings.fullName}
                                name="name"
                                inputType="text"
                                value={this.state.name}
                                onChange={this.handleProfileValueChanged}
                                validate={this.validateField}
                            />
                            {/* //**** */}
                            <SimpleSelect
                                placeholder={LocalizedStrings.salute}
                                value={this.state.userProfileData.salute}
                                name="salute"
                                onChange={this.handleProfileValueChanged}
                            >
                                <MenuItem value={'mr'}>{LocalizedStrings.mr}</MenuItem>
                                <MenuItem value={'mrs'}>{LocalizedStrings.mrs}</MenuItem>
                            </SimpleSelect>
                            <SimpleField
                                placeholder={LocalizedStrings.company}
                                name="company"
                                inputType="text"
                                value={this.state.userProfileData.company}
                                onChange={this.handleProfileValueChanged}
                                validate={this.validateField}
                            />
                            <SimpleSelect
                                placeholder={LocalizedStrings.area}
                                name="area"
                                value={this.state.userProfileData.area}
                                onChange={this.handleProfileValueChanged}
                            >
                                <MenuItem value={'area_inside_sales'}>{LocalizedStrings.area_inside_sales}</MenuItem>
                                <MenuItem value={'area_outdoor_sales'}>{LocalizedStrings.area_outdoor_sales}</MenuItem>
                                <MenuItem value={'area_marketing'}>{LocalizedStrings.area_marketing}</MenuItem>
                                <MenuItem value={'area_management'}>{LocalizedStrings.area_management}</MenuItem>
                                <MenuItem value={'area_product'}>{LocalizedStrings.area_product}</MenuItem>
                                <MenuItem value={'area_other'}>{LocalizedStrings.area_other}</MenuItem>
                            </SimpleSelect>
                            {this.state.userProfileData.area === 'area_other' && (
                                <SimpleField
                                    placeholder={LocalizedStrings.area_other_fill}
                                    name="areaOther"
                                    inputType="text"
                                    value={this.state.userProfileData.areaOther}
                                    onChange={this.handleProfileValueChanged}
                                    validate={this.validateField}
                                    error={this.state.userProfileData.area === 'area_other' && this.state.userProfileData.areaOther === ''}
                                />
                            )}
                            <SimpleField
                                placeholder={LocalizedStrings.position}
                                name="position"
                                inputType="text"
                                value={this.state.userProfileData.position}
                                onChange={this.handleProfileValueChanged}
                                validate={this.validateField}
                            />
                            {/* <SimpleField
                                placeholder={LocalizedStrings.country}
                                name="country"
                                inputType="text"
                                value={this.state.userProfileData.country}
                                onChange={this.handleProfileValueChanged}
                                validate={this.validateField}
                            /> */}
                            <SimpleSelectExt
                                placeholder={LocalizedStrings.country}
                                name="country"
                                value={this.state.userProfileData.country}
                                onChange={this.handleProfileValueChanged}
                            >
                                {Countries.map((c) => (
                                    <MenuItem key={c.code} value={c.code}>
                                        {c.name}
                                    </MenuItem>
                                ))}
                            </SimpleSelectExt>
                            <SimpleField
                                placeholder={LocalizedStrings.city}
                                name="city"
                                inputType="text"
                                value={this.state.userProfileData.city}
                                onChange={this.handleProfileValueChanged}
                                validate={this.validateField}
                            />
                            <div style={{ textAlign: 'right' }}>
                                <Button variant="outlined" onClick={this.handleSubmitUserPorfileValues}>
                                    {LocalizedStrings.updateUserProfileData}
                                </Button>
                            </div>
                            {/* //**** */}
                        </AccordionDetails>
                    </Accordion>
                    <h3>{LocalizedStrings.changePassword}</h3>
                    {this.props.isOnline === true ? (
                        <div>
                            <SimpleField
                                placeholder={LocalizedStrings.oldPassword}
                                name="password"
                                inputType="password"
                                value={this.state.oldPassword}
                                onChange={this.handleOldPasswordChange}
                                validate={this.validateField}
                                autoComplete={'password'}
                            />
                            <PasswordCreator fields={this.state.fields} onPasswordInputChange={this.onPasswordInputChange} />
                            <br />
                            <div style={{ textAlign: 'right' }}>
                                <Button variant="outlined" onClick={this.changePassword}>
                                    {LocalizedStrings.changePassword}
                                </Button>
                            </div>
                        </div>
                    ) : (
                        LocalizedStrings.deviceOfflineError
                    )}
                </div>
                <div className={columnStyleTwo} style={{ paddingBottom: '40px' }}>
                    <h3>{'Tools'}</h3>
                    <Tools isOnline={this.props.isOnline} />
                    <div style={{ position: 'absolute', bottom: 0, right: 0, textAlign: 'right' }}>
                        {this.props.isOnline === true ? (
                            this.state.logoutLoading ? (
                                <div>
                                    <Loader loading={true} size={'15px'} />
                                </div>
                            ) : (
                                <Button variant="outlined" onClick={this.handleLogout} id="logoutButton">
                                    {LocalizedStrings.logout}
                                </Button>
                            )
                        ) : (
                            LocalizedStrings.deviceOfflineError
                        )}
                    </div>
                </div>
            </div>
        );
    };

    render() {
        return (
            <div style={this.props.fullWidth === true ? { width: '100%' } : { display: 'inline-block' }}>
                <Dialog
                    fullWidth
                    maxWidth="md"
                    fullScreen={this.props.fullScreen}
                    open={this.state.isUserSettingsOpen}
                    onClose={this.closeModal}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>{this.renderContent()}</DialogContent>
                    <DialogActions>
                        {this.props.fullScreen && (
                            <Button onClick={this.closeModal} color="primary">
                                {LocalizedStrings.done}
                            </Button>
                        )}
                        <div
                            style={{
                                position: 'absolute',
                                top: '50%',
                                right: '5px',
                                transform: 'translate(0,-50%)',
                                textAlign: 'right',
                                writingMode: 'vertical-lr',
                                textOrientation: 'sideways',
                                fontSize: '10px',
                            }}
                        >
                            {`Version ${version}`}
                        </div>
                    </DialogActions>
                </Dialog>
                <div
                    style={
                        this.props.fullWidth === true
                            ? { width: '100%', lineHeight: this.props.iconPlaceholderHeight ? this.props.iconPlaceholderHeight : undefined }
                            : { display: 'inline-block' }
                    }
                    onClick={this.handleModalToggle}
                >
                    {this.props.children}
                </div>
            </div>
        );
    }
}

UserSettingsModal.propTypes = {
    fullWidth: PropTypes.bool,
    history: PropTypes.object,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    notify: PropTypes.func,
    classes: PropTypes.object.isRequired,
    fullScreen: PropTypes.bool.isRequired,
    isOnline: PropTypes.bool,
    toggleUserSettings: PropTypes.func,
    iconPlaceholderHeight: PropTypes.string,
};

const useStyles = makeStyles((theme) => ({
    formControl: {
        marginTop: '8px',
        marginBottom: '4px',
    },
    resize: {
        fontSize: 14,
    },
}));

const theme = createMuiTheme({
    palette: {
        primary: grey,
    },
});

const SimpleSelect = (props) => {
    const classes = useStyles();

    const inputLabel = React.useRef(null);
    const [labelWidth, setLabelWidth] = React.useState(0);
    React.useEffect(() => {
        setLabelWidth(inputLabel.current.offsetWidth);
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <FormControl variant="outlined" className={classes.formControl} margin="dense" fullWidth>
                <InputLabel ref={inputLabel} className={classes.resize}>
                    {props.placeholder}
                </InputLabel>
                <Select
                    name={props.name}
                    value={props.value}
                    onChange={props.onChange}
                    input={<OutlinedInput labelWidth={labelWidth} />}
                    classes={{
                        root: classes.resize,
                    }}
                    error={props.error}
                >
                    {props.children}
                </Select>
            </FormControl>
        </ThemeProvider>
    );
};
SimpleSelect.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    children: PropTypes.any,
};
export let SimpleSelectExt = withStyles(styles)(SimpleSelect);
export default withMobileDialog()(withStyles(styles)(withRouter(UserSettingsModal)));
